<template lang="pug">
.stamp
  .logo
    img(:src="logo")
  //- .address
  //-   .data(v-html="address")
  .info 
    span.label Title:
    .data {{ title }}
  .info 
    span.label DWG. No.
    .data {{ configID }}
  .info 
    span.label Drawn
    .data {{ date }}
</template>
<script>
import dayjs from "dayjs";

export default {
  name: "ProductSheetStamp",
  props: ["logo", "title", "configID", "address"],
  data() {
    return {
      now: null,
    };
  },
  computed: {
    date() {
      let date = dayjs(this.now);
      return date.format("YYYY-MM-DD HH:mm:ss");
    },
  },
  created() {
    this.now = new Date();
  },
};
</script>


<style lang="scss" scoped>
.stamp {
  display: flex;
  flex-direction: column;
  border-top: 1px solid $lightGray;

  @include mq(md, $print: true) {
    flex: 0 1 18rem;
    max-width: 18rem;
    align-self: flex-end;
    border-left: 1px solid $lightGray;
    border-radius: 3px 0 0 0;
  }
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem 1rem;
  img {
    flex: 1 1 auto;
    width: auto;
    max-width: 16rem;
  }
}
.address {
  border-bottom: 1px solid $lightGray;
}

.info {
  display: flex;
  flex-direction: column;
  padding: 0.3875rem 0.5rem 0.75rem;
  border-bottom: 1px solid $lightGray;
  &:last-child {
    border-bottom: none;
  }
}

.label {
  font-size: 0.6875rem;
  align-self: flex-start;
  text-transform: uppercase;
  font-weight: 400;
  margin-bottom: 0.125rem;
  line-height: 1;
}

.data {
  text-align: center;
  font-size: 0.6875rem;
  margin: 0.5rem 0 0;
}
</style>